import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { TextLabelPlacementEnum } from 'components/elements/custom-form-control';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import FlightPurchaseAddOnsTable from './add-ons-table';
import FlightAirlineTable from './airlines-table';
import GuestTable from './guest-table';
import { ScheduleCardHeader, ScheduleCardHeaderLeft } from '../../../style';

interface Props {
  parentIndex: number;
}

export default function FlightItem(props: Props) {
  const { t } = useTranslation();

  return (
    <>
      <CardSection>
        <ScheduleCardHeader>
          <ScheduleCardHeaderLeft>
            <Text variant="HeadingXSmall">
              {t('ticketOrders:schedule_extra', {
                extra: props.parentIndex + 1,
              })}
            </Text>
            <Input
              type="text"
              name={`approvalable.flightPurchases.${props.parentIndex}.bookingCode`}
              label={t('common:booking_code')}
              labelPlacement={TextLabelPlacementEnum.Left}
              noMargin
            />
          </ScheduleCardHeaderLeft>
        </ScheduleCardHeader>
        <Separator gap={24} />
        <GuestTable parentIndex={props.parentIndex} />
        <Separator gap={24} />

        <FlightAirlineTable parentIndex={props.parentIndex} />

        <FlightPurchaseAddOnsTable parentIndex={props.parentIndex} />
      </CardSection>
      <Separator gap={24} />
    </>
  );
}
